/* rxlib - Listagem v2.0.0 */

import Spinner from '../../spinner';
import Button from '../../buttons/button';
import { Paginacao } from '../../paginacao';
import ButtonLink from '../../buttons/button-link';
import { Table, AcoesTabela, ConfiguracoesTabela } from '../../table';
import ButtonSplit, { ButtonSplitItem } from '../../buttons/button-split';

interface ListagemProps {
    campoId: string;
    fonteDados: [{}];
    linkNovo?: string;
    textoNovo?: string;
    descricao?: string;
    className?: string;
    linkEdicao?: string;
    queryString?: string;
    onNovo?: () => void;
    carregando: boolean;
    paginaAtual?: number;
    csvFilename?: string;
    linkExclusao?: string;
    linkListagem?: string;
    idEntidadePai?: string;
    usarOrdenacao?: boolean;
    listagemDetalhe: boolean;
    linkVisualizacao?: string;
    usarExportacaoCsv?: boolean;
    onEditar?: (id: string) => void;
    onExcluir?: (id: string) => void;
    quantidadeTotalRegistros?: number;
    tipoBotaoAcao: 'button' | 'submit';
    onVisualizar?: (id: string) => void;
    acoesPersonalizadas?: AcoesTabela[];
    buttonSplitItens?: ButtonSplitItem[];
    quantidadeRegistrosPorPagina?: number;
    configuracoesTabela: ConfiguracoesTabela;
}

export function Listagem(props: ListagemProps) {
    let listagemClass = props.listagemDetalhe
        ? 'mb-5 mt-2 pt-2 px-1 border rxlib-listagem-detalhe'
        : 'mb-5 container-fluid';
    if ((props.className) && (props.className !== '')) {
        listagemClass = props.className + ' ' + listagemClass;
    }

    let textoBotaoNovo = props.textoNovo
        ? props.textoNovo
        : 'Novo';

    return (
        <div className={listagemClass}>
            <div className='row px-1'>
                {
                    props.descricao
                        ? <div className='col-7'>
                            <h6>{props.descricao}</h6>
                        </div>
                        : <div className='col-7' />
                }
                <div className='col-3' />
                <div className='col-2'>
                    {
                        ((props.linkNovo) && (props.linkNovo !== ''))
                            ? props.carregando
                                ? ''
                                : <ButtonLink
                                    link={props.linkNovo}
                                    texto={textoBotaoNovo}
                                    classStyle='btn-rxlib' />
                            : props.onNovo
                                ? props.carregando
                                    ? ''
                                    : (props.idEntidadePai !== '')
                                        ? <Button
                                            classStyle='btn-rxlib'
                                            texto={textoBotaoNovo}
                                            onClick={props.onNovo}
                                            type={props.tipoBotaoAcao} />
                                        : ''
                                : ((props.buttonSplitItens) && (props.buttonSplitItens.length > 0))
                                    ? props.carregando
                                        ? ''
                                        : <ButtonSplit
                                            classStyle='btn-rxlib'
                                            texto={textoBotaoNovo}
                                            itens={props.buttonSplitItens} />
                                    : ''
                    }
                </div>
            </div>
            <div className='row px-3'>
                {
                    props.carregando
                        ? <Spinner
                            classStyle='rxlib-spinner'
                            classNameSpinner='mt-4 mb-4'
                            classNameDiv={props.listagemDetalhe ? 'mb-3' : ''} />
                        : <Table
                            tableDetalhe={false}
                            campoId={props.campoId}
                            onEditar={props.onEditar}
                            onExcluir={props.onExcluir}
                            fonteDados={props.fonteDados}
                            linkEdicao={props.linkEdicao}
                            csvFilename={props.csvFilename}
                            onVisualizar={props.onVisualizar}
                            linkExclusao={props.linkExclusao}
                            usarOrdenacao={props.usarOrdenacao}
                            tipoBotaoAcao={props.tipoBotaoAcao}
                            configuracoes={props.configuracoesTabela}
                            linkVisualizacao={props.linkVisualizacao}
                            usarExportacaoCsv={props.usarExportacaoCsv}
                            acoesPersonalizadas={props.acoesPersonalizadas ? props.acoesPersonalizadas : []} />
                }
            </div>
            <div className='row px-3'>
                {
                    props.linkListagem
                        ? !props.carregando
                            ? <Paginacao
                                queryString={props.queryString}
                                linkListagem={props.linkListagem}
                                paginaAtual={props.paginaAtual ? props.paginaAtual : 0}
                                quantidadeTotal={props.quantidadeTotalRegistros ? props.quantidadeTotalRegistros : 0}
                                quantidadePorPagina={props.quantidadeRegistrosPorPagina ? props.quantidadeRegistrosPorPagina : 0} />
                            : ''
                        : ''
                }
            </div>
        </div>
    );
}